import type { KPI } from "@/types/kpiTypes.ts"

export const getSubRows = (kpi: KPI): KPI[] => {
  if (kpi.values?.findIndex((v) => v.type == "Actual") == -1) return []
  const types = [...new Set(kpi.values?.map((v) => v.type))].filter((t) => t != "Actual")
  return types.map((type) => ({
    id: kpi.id,
    name: `${kpi.name} ${type}`,
    unit: kpi.unit,
    values: kpi.values?.filter((v) => v.type == type),
  }))
}
